export const legal = {
  en: {
    common: {
      last_updated: "Last updated",
      back_home: "← Back to home",
      contact_us: "Contact us",
    },
    refund: {
      title: "Refund Policy",
      subtitle: "How deposits, cancellations and weather rescheduling work.",
      updated: "December 1, 2025",
      sections: [
        {
          h: "Deposits",
          p: "To secure your flight slot we charge a non-refundable online deposit ($30–$60 depending on the tour). The remaining balance is paid on the day at the launch site in cash, card or Bitcoin.",
        },
        {
          h: "Weather cancellations",
          p: "Paragliding is entirely weather-dependent. If our pilots determine that the conditions are not safe to fly (strong winds, storms, low visibility), we will offer you either (a) a rescheduled flight at no extra cost, valid for 12 months, or (b) a full refund of your deposit within 5 business days.",
        },
        {
          h: "Passenger-initiated cancellations",
          p: "Cancellations made at least 48 hours before the scheduled flight → 100% refund of the deposit. Between 24h and 48h before → 50% refund. Less than 24h or no-show → no refund.",
        },
        {
          h: "Health & weight restrictions",
          p: "Passengers with a BMI over 33, weight above 135 kg (297 lbs), or serious cardiac / spinal / neurological conditions may be refused boarding for safety reasons at the pilot's sole discretion. In such cases, the deposit is fully refunded on the spot.",
        },
        {
          h: "Refunds process",
          p: "Refunds are processed through Stripe to the original payment method within 5–10 business days. For crypto payments, refunds are converted back to USD at the prevailing exchange rate at time of refund. Bank fees, if any, are non-refundable.",
        },
        {
          h: "How to request a refund",
          p: "Email hello@paraglidetour.com with your booking ID and reason. We respond within 24 hours.",
        },
      ],
    },
    privacy: {
      title: "Privacy Policy",
      subtitle: "What data we collect, why we collect it, and your rights.",
      updated: "December 1, 2025",
      sections: [
        {
          h: "Who we are",
          p: "#ParaglideTour is a specialized tandem paragliding operator, connecting you with the world's best pilot instructors — professionals with real, documented experience — and handpicking launch sites with some of the most spectacular views on the planet.  Our mission is simple: to make the wonderful privilege of flying accessible to everyone, with complete safety, in the most incredible places in the world.  Contact: hello@paraglidetour.com",
        },
        {
          h: "What we collect",
          p: "Booking form: name, email, phone, preferred flight date, passenger count, package selection, and optional notes. Payment: card data is handled entirely by Stripe — we never see or store card numbers. Analytics: anonymous PostHog events (page views, clicks, scroll depth) to improve the site.",
        },
        {
          h: "Why we collect it",
          p: "To confirm your reservation, contact you about scheduling changes, process payments through Stripe, comply with civil aviation record-keeping requirements, and improve our website experience.",
        },
        {
          h: "Sharing with third parties",
          p: "We share your data only with: (i) Stripe, for payment processing; (ii) Google/PostHog for anonymous analytics; (iii) Costa Rican & Brazilian civil aviation authorities if legally required. We never sell your data.",
        },
        {
          h: "Data retention",
          p: "Booking records are kept for 5 years to meet aviation safety requirements. Marketing contacts are kept until you unsubscribe. Anonymous analytics are retained for 12 months.",
        },
        {
          h: "Your rights",
          p: "Under LGPD (Brazil), GDPR (EU visitors) and Costa Rica's Ley N.º 8968, you can request access, correction, portability or deletion of your personal data at any time by writing to hello@paraglidetour.com.",
        },
        {
          h: "Cookies",
          p: "We use essential cookies (language preference), and analytics cookies (PostHog). No advertising cookies. You can clear cookies in your browser at any time.",
        },
        {
          h: "Changes to this policy",
          p: "We may update this policy occasionally. Material changes will be notified via a banner on the site 30 days in advance.",
        },
      ],
    },
  },
  es: {
    common: {
      last_updated: "Última actualización",
      back_home: "← Volver al inicio",
      contact_us: "Contactanos",
    },
    refund: {
      title: "Política de Reembolso",
      subtitle: "Cómo funcionan los depósitos, cancelaciones y reprogramaciones por clima.",
      updated: "1 de diciembre de 2025",
      sections: [
        {
          h: "Depósitos",
          p: "Para asegurar tu cupo cobramos un depósito online no reembolsable ($30–$60 según el tour). El saldo se paga el mismo día en el sitio de despegue en efectivo, tarjeta o Bitcoin.",
        },
        {
          h: "Cancelaciones por clima",
          p: "El parapente depende totalmente del clima. Si nuestros pilotos determinan que las condiciones no son seguras para volar (vientos fuertes, tormentas, baja visibilidad), te ofrecemos (a) reprogramar el vuelo sin costo, válido por 12 meses, o (b) un reembolso completo del depósito en 5 días hábiles.",
        },
        {
          h: "Cancelaciones del pasajero",
          p: "Cancelaciones con al menos 48 horas de anticipación → 100% de reembolso del depósito. Entre 24h y 48h antes → 50% de reembolso. Menos de 24h o no-show → sin reembolso.",
        },
        {
          h: "Restricciones de salud y peso",
          p: "Pasajeros con IMC superior a 33, peso mayor a 135 kg (297 lbs), o condiciones cardíacas / de columna / neurológicas graves pueden no ser abordados por seguridad a criterio del piloto. En estos casos, el depósito se reembolsa en el momento.",
        },
        {
          h: "Proceso de reembolso",
          p: "Los reembolsos se procesan por Stripe al método de pago original en 5–10 días hábiles. Los pagos en cripto se reembolsan convertidos a USD al tipo de cambio del momento. Las comisiones bancarias, si las hubiere, no son reembolsables.",
        },
        {
          h: "Cómo solicitar un reembolso",
          p: "Escribí a hello@paraglidetour.com con tu ID de reserva y motivo. Respondemos en menos de 24 horas.",
        },
      ],
    },
    privacy: {
      title: "Política de Privacidad",
      subtitle: "Qué datos recopilamos, por qué lo hacemos y tus derechos.",
      updated: "1 de diciembre de 2025",
      sections: [
        {
          h: "Quiénes somos",
          p: "#ParaglideTour es una operadora especializada en vuelos biplaza de parapente, que te conecta con los mejores pilotos instructores del mundo — profesionales con experiencia real y documentada — y selecciona rampas con algunas de las vistas más espectaculares del planeta.  Nuestra misión es simple: hacer accesible el maravilloso privilegio de volar, con total seguridad, en los lugares más increíbles del mundo.  Contacto: hello@paraglidetour.com",
        },
        {
          h: "Qué recopilamos",
          p: "Formulario de reserva: nombre, correo, teléfono, fecha preferida, cantidad de pasajeros, tour elegido y notas opcionales. Pagos: los datos de tarjeta los maneja Stripe — nunca los vemos ni los guardamos. Analítica: eventos anónimos de PostHog (páginas vistas, clics, scroll) para mejorar el sitio.",
        },
        {
          h: "Por qué lo recopilamos",
          p: "Para confirmar tu reserva, contactarte por cambios de horario, procesar pagos con Stripe, cumplir requisitos de aviación civil y mejorar la experiencia del sitio.",
        },
        {
          h: "Compartir con terceros",
          p: "Compartimos tus datos solo con: (i) Stripe, para procesar pagos; (ii) Google/PostHog para analítica anónima; (iii) autoridades de aviación civil de Costa Rica y Brasil cuando la ley lo exija. Nunca vendemos tus datos.",
        },
        {
          h: "Retención de datos",
          p: "Los registros de reservas se guardan 5 años por normas de aviación. Contactos de marketing hasta que solicites baja. Analítica anónima 12 meses.",
        },
        {
          h: "Tus derechos",
          p: "Bajo LGPD (Brasil), GDPR (visitantes UE) y Ley N.º 8968 (Costa Rica), podés solicitar acceso, corrección, portabilidad o borrado de tus datos escribiendo a hello@paraglidetour.com.",
        },
        {
          h: "Cookies",
          p: "Usamos cookies esenciales (preferencia de idioma) y de analítica (PostHog). Sin cookies publicitarias. Podés borrarlas en tu navegador cuando quieras.",
        },
        {
          h: "Cambios en esta política",
          p: "Podemos actualizar esta política ocasionalmente. Los cambios importantes se notifican con un banner en el sitio 30 días antes.",
        },
      ],
    },
  },
  pt: {
    common: {
      last_updated: "Última atualização",
      back_home: "← Voltar ao início",
      contact_us: "Fale conosco",
    },
    refund: {
      title: "Política de Reembolso",
      subtitle: "Como funcionam depósitos, cancelamentos e remarcações por clima.",
      updated: "1 de dezembro de 2025",
      sections: [
        {
          h: "Depósitos",
          p: "Para garantir seu horário cobramos um depósito online não reembolsável (US$30–US$60 conforme o tour). O saldo é pago no dia, no local de decolagem, em dinheiro, cartão ou Bitcoin.",
        },
        {
          h: "Cancelamento por clima",
          p: "Parapente depende inteiramente do clima. Se nossos pilotos determinarem que as condições não são seguras (vento forte, tempestade, baixa visibilidade), oferecemos (a) remarcação sem custo, válida por 12 meses, ou (b) reembolso integral do depósito em até 5 dias úteis.",
        },
        {
          h: "Cancelamento pelo passageiro",
          p: "Cancelamentos com pelo menos 48 horas de antecedência → 100% de reembolso do depósito. Entre 24h e 48h antes → 50% de reembolso. Menos de 24h ou não comparecimento → sem reembolso.",
        },
        {
          h: "Restrições de saúde e peso",
          p: "Passageiros com IMC acima de 33, peso acima de 135 kg (297 lbs), ou condições cardíacas / de coluna / neurológicas graves podem ser recusados no embarque por segurança a critério do piloto. Nesses casos, o depósito é reembolsado no ato.",
        },
        {
          h: "Processo de reembolso",
          p: "Reembolsos são processados via Stripe no mesmo método de pagamento em 5–10 dias úteis. Pagamentos em cripto retornam em USD pela cotação do momento do reembolso. Taxas bancárias, se houver, não são reembolsáveis.",
        },
        {
          h: "Como solicitar reembolso",
          p: "Envie um e-mail para hello@paraglidetour.com com seu ID de reserva e motivo. Respondemos em até 24 horas.",
        },
      ],
    },
    privacy: {
      title: "Política de Privacidade",
      subtitle: "Quais dados coletamos, por quê e quais são seus direitos.",
      updated: "1 de dezembro de 2025",
      sections: [
        {
          h: "Quem somos",
          p: "ParaglideTour é uma operadora especializada em voos duplos de parapente, que conecta você aos melhores pilotos instrutores do mundo — profissionais com experiência real e documentada — e seleciona rampas com algumas das vistas mais espetaculares do planeta. Nossa missão é simples: tornar acessível o privilégio maravilhoso de voar, com toda a segurança, nos lugares mais incríveis do mundo. Contato: hello@paraglidetour.com",
        },
        {
          h: "O que coletamos",
          p: "Formulário de reserva: nome, e-mail, telefone, data preferida, número de passageiros, tour escolhido e observações. Pagamentos: dados de cartão são manuseados exclusivamente pelo Stripe — nunca vemos nem armazenamos. Analytics: eventos anônimos do PostHog (pageviews, cliques, scroll) para melhorar o site.",
        },
        {
          h: "Por que coletamos",
          p: "Para confirmar sua reserva, contatar você sobre mudanças de horário, processar pagamentos via Stripe, atender exigências da aviação civil e melhorar a experiência do site.",
        },
        {
          h: "Compartilhamento com terceiros",
          p: "Seus dados são compartilhados apenas com: (i) Stripe, para processamento de pagamentos; (ii) Google/PostHog para analytics anônimo; (iii) autoridades de aviação civil da Costa Rica e do Brasil quando legalmente exigido. Nunca vendemos seus dados.",
        },
        {
          h: "Retenção de dados",
          p: "Registros de reserva são mantidos por 5 anos para atender exigências de aviação. Contatos de marketing até você pedir descadastro. Analytics anônimo é mantido por 12 meses.",
        },
        {
          h: "Seus direitos",
          p: "Sob a LGPD (Brasil), GDPR (visitantes UE) e Lei nº 8968 (Costa Rica), você pode solicitar acesso, correção, portabilidade ou exclusão dos seus dados escrevendo para hello@paraglidetour.com.",
        },
        {
          h: "Cookies",
          p: "Usamos cookies essenciais (preferência de idioma) e de analytics (PostHog). Sem cookies publicitários. Você pode limpar os cookies no navegador a qualquer momento.",
        },
        {
          h: "Alterações nesta política",
          p: "Podemos atualizar esta política ocasionalmente. Mudanças relevantes serão avisadas com banner no site 30 dias antes.",
        },
      ],
    },
  },
};
